var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLupa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4942 0C14.3749 0 6.98734 7.39123 6.98734 16.5063C6.98262 19.5092 7.80114 22.4559 9.35393 25.0262L1.35094 33.0292L1.37879 33.057C0.524592 33.8746 9.88198e-08 35.0352 9.88198e-08 36.347C-0.000515724 38.8812 2.01841 40.863 4.55007 40.8625C5.84324 40.862 6.99972 40.3446 7.82503 39.5028L7.84515 39.5229L16.1024 31.2651C18.3961 32.4167 20.9276 33.0152 23.4942 33.0127C32.6139 33.0127 40 25.6225 40 16.5063C40 7.39123 32.6134 0 23.4942 0ZM23.5942 26.5221C17.8944 26.5221 13.2773 21.9034 13.2773 16.2056C13.2773 10.5089 17.8944 5.88915 23.5942 5.88915C29.2941 5.88915 33.9102 10.5083 33.9102 16.2056C33.9107 21.9034 29.2941 26.5221 23.5942 26.5221Z",
    fill: "#EFC155"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLupa);
export default __webpack_public_path__ + "static/media/lupa.4a569a1ada4d7ef4de2c0ff805a12d97.svg";
export { ForwardRef as ReactComponent };